var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.64,-16.64) scale(1.13,1.13)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,3.00195c-0.359,0 -0.68919,0.19286 -0.86719,0.50586c-0.179,0.312 -0.17423,0.69686 0.00977,1.00586c0.013,0.021 1.35742,2.31533 1.35742,4.98633c0,1.495 -0.66991,2.72248 -1.37891,4.02148c-0.798,1.462 -1.62109,2.97352 -1.62109,4.97852c0,2.156 2.39669,3.95823 5.42969,6.24023c3.783,2.847 8.07031,6.07177 8.07031,10.25977c0,3.674 -1.50863,7.03847 -4.14062,9.23047c-0.404,0.338 -0.47897,0.93438 -0.16797,1.35938c0.195,0.267 0.50055,0.4082 0.81055,0.4082c0.184,0 0.36916,-0.0493 0.53516,-0.1543c5.976,-3.803 7.71891,-9.05792 8.12891,-12.79492c0.513,-4.665 -0.81036,-9.0042 -2.44336,-11.1582c0.836,-1.63 1.04574,-3.62542 0.55273,-5.48242c-0.514,-1.934 -1.72713,-3.50173 -3.32812,-4.30273c-0.386,-0.193 -0.84734,-0.11755 -1.15234,0.18945c-0.305,0.305 -0.38145,0.76834 -0.18945,1.15234c0.537,1.073 0.71633,2.95269 0.11133,3.92969c-0.263,0.426 -0.6508,0.62305 -1.2168,0.62305c-0.863,0 -1.15981,-0.34017 -1.25781,-0.45117c-0.783,-0.898 -0.48094,-3.09539 -0.33594,-4.15039c0.055,-0.399 0.09375,-0.71249 0.09375,-0.89649c0,-3.873 -2.727,-9.5 -7,-9.5zM22.84766,5.01172c-0.488,0.075 -0.84766,0.49528 -0.84766,0.98828c0,2.129 -2.0128,3.81839 -4.3418,5.77539c-3.121,2.622 -6.6582,5.59461 -6.6582,10.72461c0,2.92 2.92681,5.57688 5.50781,7.92188c1.556,1.413 3.49219,3.17213 3.49219,4.07813c0,0.747 -0.618,1.5 -2,1.5c-4.977,0 -7.1663,-5.79119 -8.0293,-9.24219c-0.12,-0.481 -0.57836,-0.79695 -1.06836,-0.75195c-0.494,0.049 -0.87739,0.45227 -0.90039,0.94727c-0.289,6.172 1.18763,11.00337 4.39062,14.35938c4.256,4.462 9.99942,4.6875 11.10742,4.6875c4.623,0 11.5,-2.396 11.5,-9c0,-5.459 -4.49589,-8.78184 -8.46289,-11.71484c-2.848,-2.104 -5.53711,-4.09316 -5.53711,-6.28516c0,-2.571 0.90144,-4.39234 1.77344,-6.15234c1.032,-2.082 2.09969,-4.23544 1.17969,-7.14844c-0.148,-0.472 -0.61447,-0.7605 -1.10547,-0.6875z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/FireIcon.ff1d355caadafe74cf976dcaaf137237.svg";
export { ForwardRef as ReactComponent };